import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "shortform-sign-up__partition" }
const _hoisted_3 = { class: "shortform-sign-up__partition-text d-md-none" }
const _hoisted_4 = { class: "shortform-sign-up__other-way" }

import { onBeforeMount, ref } from 'vue'

import {
  SocialAuthComponentView,
  createSocialAuthView,
} from '@/models/auth/social'

import FormError from '@/components/ui/FormError.vue'
import GoogleSignInButton from './GoogleSignInButton.vue'
import FacebookLoginButton from './FacebookLoginButton.vue'
import AppleSignInButton from './AppleSignInButton.vue'
import { AuthMode } from '@/models/auth/google'


export default /*@__PURE__*/_defineComponent({
  __name: 'SocialAuth',
  props: {
    onStart: {},
    onSuccess: {},
    onError: {},
    authMode: {},
    showGoogle: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

const title = ref('')

const socialView = ref<SocialAuthComponentView | null>(null)

onBeforeMount(async () => {
  title.value =
    props.authMode === AuthMode.Signin ? 'Sign in with' : 'Sign up with'

  socialView.value = await createSocialAuthView(
    props.onStart,
    props.onSuccess,
    props.onError,
  )
  if (socialView.value) {
    socialView.value.init()
  }
})

return (_ctx: any,_cache: any) => {
  return (socialView.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "shortform-sign-up__partition-text d-none d-md-block" }, "Or", -1)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(title.value), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(FormError, {
            errors: socialView.value.validation.errors,
            field: "social"
          }, null, 8, ["errors"]),
          (__props.showGoogle)
            ? (_openBlock(), _createBlock(GoogleSignInButton, {
                key: 0,
                authMode: __props.authMode,
                view: socialView.value.googleAuthView
              }, null, 8, ["authMode", "view"]))
            : _createCommentVNode("", true),
          _createVNode(FacebookLoginButton, {
            title: title.value,
            view: socialView.value.facebookAuthView
          }, null, 8, ["title", "view"]),
          (socialView.value.appleAuthView)
            ? (_openBlock(), _createBlock(AppleSignInButton, {
                key: 1,
                view: socialView.value.appleAuthView,
                title: title.value
              }, null, 8, ["view", "title"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})